// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Container from '@mui/material/Container';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import Pagination from '@components/common/Pagination';
import ListTitle from '@components/MansionNavigation/ListTitle';
import CitiesSearchFilter from '@components/MansionNavigation/CitiesSearchFilter';
import StationsSearchFilter from '@components/MansionNavigation/StationsSearchFilter';
import ListTotal from '@components/MansionNavigation/ListTotal';
import ListSortMenu from '@components/MansionNavigation/ListSortMenu';
import { useMeta } from '@providers/MansionNavigation/MetaProvider';
import MansionCard from '@components/MansionCard';
import MansionCardSP from '@components/MansionCard/SP';

// Section for type definition -----------------------------------------------------------------------------------------
import MetaCitiesSearchFilter from '@/types/components/MansionNavigation/MetaCitiesSearchFilter';
import MetaStationsSearchFilter from '@/types/components/MansionNavigation/MetaStationsSearchFilter';

export default function MansionsList(props: any) {
  const { mansionsData } = props;

  const { isMobile } = useContext(AppConfigContext);
  const { meta } = useMeta();

  const urlParams = new URLSearchParams(window.location.search);
  const hasCitiesId = urlParams.has('city_id');
  const hasStationId = urlParams.has('station_id');

  const isCitiesInURL = window.location.href.includes('cities') || hasCitiesId;
  const isStationsInURL = window.location.href.includes('stations') || hasStationId;

  const currentSearchFilter: MetaCitiesSearchFilter | MetaStationsSearchFilter | any = meta.current_search_filter;

  // Section for render component --------------------------------------------------------------------------------------
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <Box>
      {isMobile ? (
        <Box>
          <Box className="mx-5 pt-2">
            <ListTitle title={meta.current_search_title} />
          </Box>
          <Box className="my-4">
            {isCitiesInURL && <CitiesSearchFilter currentSearchFilter={currentSearchFilter} total={meta.page.total} />}
            {isStationsInURL && (
              <StationsSearchFilter currentSearchFilter={currentSearchFilter} total={meta.page.total} />
            )}
          </Box>
          <Box className="mx-8 mb-8 relative">
            <Box className="flex justify-between">
              <ListTotal total={meta.page.total} />
              <ListSortMenu sortMenu={meta.current_sort} />
            </Box>
          </Box>
          <List
            sx={{
              width: '100%',
              borderTop: '1px solid #e0e0e0',
              borderRadius: '4px',
              overflow: 'hidden',
            }}
          >
            {mansionsData.map((mansion: any) => (
              <ListItem key={mansion.id} divider className="max-md:p-0 max-md:w-full">
                <MansionCardSP data={mansion} />
              </ListItem>
            ))}
          </List>
        </Box>
      ) : (
        // Section for render PC mode ----------------------------------------------------------------------------------
        <Box>
          <Box className="mx-40 pt-16">
            <ListTitle title={meta.current_search_title} />
            <Box>
              {isCitiesInURL && (
                <CitiesSearchFilter currentSearchFilter={currentSearchFilter} total={meta.page.total} />
              )}
              {isStationsInURL && (
                <StationsSearchFilter currentSearchFilter={currentSearchFilter} total={meta.page.total} />
              )}
            </Box>
            <Box className="my-8 flex justify-between">
              <ListTotal total={meta.page.total} />
              <ListSortMenu sortMenu={meta.current_sort} />
            </Box>
          </Box>
          <Container className="md:max-w-none md:flex md:flex-wrap md:justify-center md:gap-x-7 md:gap-y-10 w-full md:px-24">
            {mansionsData.map((mansion: any) => (
              <MansionCard key={mansion.id} data={mansion} />
            ))}
          </Container>
        </Box>
      )}
      <Pagination pageData={meta.page} />
    </Box>
  );
}
